import { Component } from '@angular/core';
import { buildInfo } from '../../../../../environments/build-info';

@Component({
  selector: 'app-version-details',
  standalone: false,
  template: `
    <p>{{ 'GLOBAL_LBL_VERSION' | translate }} {{ this.version }}</p>
  `,
  styles: ``,
})
export class VersionDetailsComponent {
  readonly version = buildInfo.version;
}
